import React, { useState } from 'react';
import { service } from '../../../../_services/conversation.service';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { Button, Modal } from 'react-bootstrap';

function ReopenAction({ conversationId, handleReopen }) {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [opening, setOpening] = useState(false);

  const handleOpen = () => {
    setOpening(true);
    service.reopenConversation(conversationId)
      .then(() => {
        setShow(false)
        handleReopen();
      })
      .catch(() => {
        setShow(false)
        setOpening(false);
        dispatch(alertActions.error('Could not reopen this conversation at this time. Please try again later.'));
      });
  }

  return <>
    <button onClick={() => setShow(true)}
      type="button"
      className="btn btn-success w-100">Reopen Message</button>

    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Reopen Message</Modal.Title>
      </Modal.Header>

      <Modal.Body>Reopening the message will allow you and the patient to message each other again. Are you sure you want to reopen?</Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleOpen}
          variant="primary"
          disabled={opening}
          className='w-25'
        >{opening ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Yes'}</Button>

        <Button disabled={opening} variant="secondary" onClick={() => setShow(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default ReopenAction;